import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

export default {
  id: 'States',
  type: 'WMS',
  url: 'https://www.wfas.net/cgi-bin/mapserv?service=wms',
  title: {
    'en-US': 'States',
    'pt-BR': 'Estadas',
    'es-ES': 'Estados',
    'fr-FR': 'États'
  },
  zindex: 1, // TODO: CHECK
  active: false,
  activeTarget: 'visibility',
  customProperties: { group: 'reference' },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'states_new',
      visible: true,
      layers: 'states_new',
      legend: {
        title: {
          'en-US': 'States',
          'pt-BR': 'Estadas',
          'es-ES': 'Estados',
          'fr-FR': 'États'
        },
        items: [
          {
            text: {
              'en-US': 'States',
              'pt-BR': 'Estadas',
              'es-ES': 'Estados',
              'fr-FR': 'États'
            },
            color: '#744588',
            icon: 'mdi-minus'
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley'
} as LayerRaw
